import React from 'react'

const SpeciesContext = React.createContext({
    species: 'andorian'
})

export default SpeciesContext